import { tipoPropostaOptions } from "../utils/propostaConstants";

type Option = { value: string; label: string };

type TipoPropostaSelectorProps = {
  value?: string;
  disabled?: boolean;
  onChange: (value: string) => void;
  options?: Option[];
  ariaLabel?: string;
  columns?: 2 | 3;
};

export default function TipoPropostaSelector({
  value,
  disabled,
  onChange,
  options = tipoPropostaOptions,
  ariaLabel = "Tipo de proposta",
  columns = 3,
}: TipoPropostaSelectorProps) {
  const columnsClass =
    columns === 2 ? " proposta-tipo-options--2" : "";

  return (
    <div
      className={`proposta-tipo-options${columnsClass}`}
      role="radiogroup"
      aria-label={ariaLabel}
    >
      {options.map((opt) => {
        const active = String(value || "") === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            role="radio"
            aria-checked={active}
            disabled={disabled}
            className={`proposta-tipo-option${active ? " is-active" : ""}`}
            onClick={() => onChange(opt.value)}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
